<template>
	<AppScreen class="postgame-view" :scrollable="false">
		<NGPFLogo />
		<div class="content">
			<h1 class="title">{{ title }}</h1>
			<CMSComponent class="subtitle" :content="subtitle" :props="{ finalBalance }" />
			<p class="message wysiwyg-content" v-html="end_game_message"></p>
			<div :class="['btn-container', { 'hideSocial': isBrainPop }]">
				<Button class="play-again" :action="start">{{ button_text }}</Button>
				<SocialShare class="social-share" />
			</div>
		</div>
	</AppScreen>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { currencyFormatter } from "@/lib/formatters";
import AppScreen from '@/components/partials/AppScreen';
import Button from '@/components/base/Button';
import CMSComponent from '@/components/base/CMSComponent';
import NGPFLogo from '@/components/base/NGPFLogo';
import SocialShare from '@/components/base/SocialShare';

export default {
	name: 'IntroScreen',
	components: {
		AppScreen,
		Button,
		CMSComponent,
		NGPFLogo,
		SocialShare,
	},
	props: {
		title: {
			type: String,
			required: true,
		},
		subtitle: {
			type: String,
			required: true,
		},
		end_game_message: {
			type: String,
			required: true,
		},
		button_text: {
			type: String,
			required: true,
		},
	},
	computed: {
		...mapGetters('game/funds', {
			win: 'surplus',
			lose: 'balancesNeeded',
		}),
		...mapState({
			outcome: (state) => state.game.outcome,
			isBrainPop: (state) => state.global.api.data.config.brain_pop,
		}),
		finalBalance() {
			const balance = this.outcome === 'win' ? this.win : this.lose;
			return currencyFormatter.format(balance);
		},
	},
	methods: {
		start() {
			window.location.replace("/game/start");
		},
	},
};
</script>

<style lang="scss" scoped>
	.postgame-view { background: $background-color; }

	.content {
		color: $off-white-dark;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		width: 800px;
	}

	.title {
		text-transform: uppercase;
		font-size: $heading-size-x-lg;
		color: $alt-color;
		line-height: 1.2;

		@include mobile { font-size: $heading-size-sm; }
	}

	.subtitle {
		text-transform: uppercase;
		color: $primary-color;
		margin: 0;
	}

	.message {
		margin: 2rem 0;
		font-family: $body-font-alt;
		width: 75%;

		@include mobile {
			margin: 1rem 0;
			font-size: $font-size-x-sm;
		}
	}

	.btn-container {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 40%;

		@include mobile { justify-content: space-around; }

		&.hideSocial {
			justify-content: center;

			.share-group { display: none; }
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/PostGame.vue